import React from 'react';
import PropTypes from 'prop-types';
import { AdviseBannerContainer, TermsAndConditionsNotification } from './AdviseBanner.styles';

function AdviseBanner({ shouldRenderTermsAndConditionsNotification }) {
    return (
        <AdviseBannerContainer>
            Please note: this page is for hosts and presenters only. Do not share this URL with your guests.
            {shouldRenderTermsAndConditionsNotification && (
                <TermsAndConditionsNotification>
                    By proceeding to the event, I agree that I have read, understand, and agree to be bound by Splash’s{' '}
                    <a href="https://splashthat.com/terms" target="_blank">
                        Terms and Conditions
                    </a>{' '}
                    and{' '}
                    <a href="https://splashthat.com/privacy" target="_blank">
                        Privacy Policy
                    </a>
                    .
                </TermsAndConditionsNotification>
            )}
        </AdviseBannerContainer>
    );
}

export default AdviseBanner;

AdviseBanner.propTypes = {
    shouldRenderTermsAndConditionsNotification: PropTypes.bool.isRequired,
};
